import { StepMap } from "@/components/onboarding/components/welcome-wizard/welcome-wizard.types";
import { SystemPermissionsVoicePermissionsStep } from "./voice-permissions-step";
import { SystemPermissionsRestartIfRequiredStep } from "./restart-if-required-step";

export const SystemPermissionsVoiceStepsMap: StepMap = {
  "system-permissions-voice-permissions": {
    id: "system-permissions-voice-permissions",
    group: "system-permissions-voice",
    render: props => <SystemPermissionsVoicePermissionsStep {...props} />,
    fullHeight: true,
  },
  "system-permissions-restart-if-required": {
    id: "system-permissions-restart-if-required",
    group: "system-permissions-voice",
    render: props => <SystemPermissionsRestartIfRequiredStep {...props} />,
    fullHeight: true,
  },
} as const;
